import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { connectTelegram, PENDING_TELEGRAM_CONNECT } from "../../api/chat_api";

/**
 * /connect-telegram?code=…  — opened from the bot's Telegram /connect message.
 *
 * Signed in: hand the bot this browser's login for the code's Telegram chat.
 * Signed out: park the code, send the user to /login; Login returns here.
 * No password is ever typed into Telegram — the login stays on this site.
 */
export default function ConnectTelegram() {
    const navigate = useNavigate();
    const { search } = useLocation();
    const ran = useRef(false);
    const [state, setState] = useState({ phase: "working", message: "" });

    useEffect(() => {
        if (ran.current) return;
        ran.current = true;
        const code = new URLSearchParams(search).get("code") || sessionStorage.getItem(PENDING_TELEGRAM_CONNECT);
        if (!code) {
            setState({ phase: "error", message: "This link has no connect code. Send /connect to the bot in Telegram for a new one." });
            return;
        }
        if (!sessionStorage.getItem("authToken")) {
            sessionStorage.setItem(PENDING_TELEGRAM_CONNECT, code);
            navigate("/login", { replace: true });
            return;
        }
        sessionStorage.removeItem(PENDING_TELEGRAM_CONNECT);
        connectTelegram(code).then((res) => {
            if (res.success) {
                setState({ phase: "done", message: "Telegram is connected. Go back to Telegram — the bot will answer there using your FactorAlpha login." });
            } else if (res.authExpired) {
                sessionStorage.setItem(PENDING_TELEGRAM_CONNECT, code);
                navigate("/login", { replace: true });
            } else {
                setState({ phase: "error", message: res.error || "Could not connect Telegram." });
            }
        });
    }, [search, navigate]);

    const box = {
        maxWidth: 460, margin: "12vh auto", padding: "2rem", borderRadius: 12, textAlign: "center",
        background: "var(--color-bg-secondary, #fff)", color: "var(--color-text-primary, #111)",
        border: "1px solid var(--color-border, #e5e7eb)", fontFamily: "inherit",
    };
    const btn = {
        marginTop: "1.25rem", padding: "0.6rem 1.4rem", borderRadius: 8, border: "none", cursor: "pointer",
        background: "var(--color-primary, #0096FF)", color: "#fff", fontWeight: 600,
    };
    return (
        <div style={{ minHeight: "100vh", background: "var(--color-bg-primary, #F8FAFC)", padding: "1rem" }}>
            <div style={box}>
                <h2 style={{ margin: "0 0 0.75rem" }}>
                    {state.phase === "done" ? "✅ Connected" : state.phase === "error" ? "Couldn't connect" : "Connecting Telegram…"}
                </h2>
                <p style={{ color: "var(--color-text-secondary, #6B7280)", margin: 0 }}>
                    {state.phase === "working" ? "Linking your Telegram chat to this FactorAlpha account." : state.message}
                </p>
                {state.phase !== "working" && (
                    <button style={btn} onClick={() => navigate("/dashboard")}>Go to dashboard</button>
                )}
            </div>
        </div>
    );
}
